import React, { useMemo, useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import I18n from 'i18n-js';
import { format as dateFnsFormat } from 'date-fns';
import _get from 'lodash/get';
import {
  ongoingDeliveriesV2Selector,
  waybillSelector,
} from 'selectors/new-history-selectors';
import { ExceptMobile } from 'components/v2/responsive';
import {
  WAYBILLS_ORDERS_KEY,
  WAYBILLS_PAGE_READY,
} from 'constants/app-constants';
import { useFilteredOngoingOrder } from './common-hooks';
import OngoingBookingAction from './ongoing-booking-action';
import OngoingBookingFilter from './ongoing-booking-filter';
import OngoingBookingTable from './ongoing-booking-table';
import commonStyles from './new-booking-table-page.less';
import useCancelDeliveries from './use-cancel-deliveries/useCancelDeliveries';

const OngoingBookingSection = () => {
  const { lastUpdated } = useSelector(ongoingDeliveriesV2Selector);
  const { deliveries } = useSelector(ongoingDeliveriesV2Selector);
  const waybill = useSelector(waybillSelector);

  const ordersToDisplay = useFilteredOngoingOrder();
  const lastUpdatedAt = useMemo(
    () => (lastUpdated ? dateFnsFormat(lastUpdated, 'HH:mm:ss') : '...'),
    [lastUpdated],
  );

  const waybillListener = useCallback(
    evt => {
      if (evt.origin !== window.location.origin) return;

      const readyEvent = _get(evt, `data.${WAYBILLS_PAGE_READY}`);
      const windowName = _get(evt, 'source.name');
      if (!readyEvent || !windowName) return;

      const ordersForPage = _get(waybill, windowName);
      if (!ordersForPage) return;

      evt.source.postMessage({ [WAYBILLS_ORDERS_KEY]: ordersForPage });
    },
    [waybill],
  );

  useEffect(
    () => {
      window.addEventListener('message', waybillListener);
      return () => window.removeEventListener('message', waybillListener);
    },
    [waybillListener],
  );

  const {
    modalDOMs: cancellationModalDOMs,
    startCancellation,
  } = useCancelDeliveries();

  return (
    <React.Fragment>
      {deliveries && (
        <div className={commonStyles.section}>
          <div className={commonStyles.header}>
            <h5>
              {I18n.t('v2.homepage.orderOverview.ongoingBooking.title', {
                amt: ordersToDisplay.length,
              })}
            </h5>
            <ExceptMobile>
              <h6>
                {I18n.t('v2.bookingsPage.lastUpdatedAt', {
                  time: lastUpdatedAt,
                })}
              </h6>
            </ExceptMobile>
          </div>
          <div className={commonStyles.filterAction}>
            <OngoingBookingFilter />
            <OngoingBookingAction startCancellation={startCancellation} />
          </div>
          <OngoingBookingTable startCancellation={startCancellation} />
        </div>
      )}
      {cancellationModalDOMs}
    </React.Fragment>
  );
};

export default OngoingBookingSection;
